import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";

import SwiperCore from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

SwiperCore.use([Navigation, Pagination, Autoplay]);

const TestimonialsCarousel = () => {
  return (
    <div className="testimonials-carousel">
      <h2>Client Testimonials</h2>

      <Swiper
        spaceBetween={50}
        slidesPerView={1}
        loop={true}
        autoplay={{
          delay: 4000,
        }}
        navigation={{
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }}
        pagination={{
          clickable: true,
        }}
      >
        <SwiperSlide>
          <div className="testimonial">
            <p>
              “Partnering with Porto Consulting has been an invaluable decision
              for our organization. Their commitment to excellence and ability
              to understand our unique challenges have made them a trusted
              advisor for our data center initiatives.”
            </p>
            <h3>Daniel Carter</h3>
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div className="testimonial">
            <p>
              “Working with Porto Consulting has been a game-changer for our
              business. Their expertise in Nuclear power consulting has truly
              transformed our operations and positioned us for sustained
              success.”
            </p>
            <h3>Jason Strauss</h3>
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div className="testimonial">
            <p>
              “Porto Consulting's dedication and proficiency in delivering
              tailored technology solutions are unmatched. Their team has been
              instrumental in driving our business growth through innovative
              strategies.”
            </p>
            <h3>Sophia Reynolds</h3>
          </div>
        </SwiperSlide>

        <div className="swiper-button-next">
          <i className="fas fa-chevron-right"></i>
        </div>
        <div className="swiper-button-prev">
          <i className="fas fa-chevron-left"></i>
        </div>
      </Swiper>
    </div>
  );
};

export default TestimonialsCarousel;
